export default {
      id: "common__chat-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__chat",
      toString: function () {
        return this.url;
      }
    }